import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare const heap: { load: (appId: string) => void };

@Injectable({ providedIn: 'root' })
export class HeapService {
    init(): void {
        if (environment.heapAppId) {
            heap.load(environment.heapAppId);
        }
    }
}
